<div class="form-group">
    <label class="label-for-pair {{large ? 'label-for-pair--large' : '' }}">
        {{label | translate}}
        {{model | translate}}
    </label>
</div>